<script>
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import { settingsStore } from '../../stores/settingsStore.js';

  const { formData, error, performSaveWithToast } = settingsStore;

  async function switchPlatform(platform) {
    if ($formData.accountingPlatform === platform) return;
    const previousPlatform = $formData.accountingPlatform;
    error.set(null);
    formData.update((current) => ({ ...current, accountingPlatform: platform }));
    try {
      await performSaveWithToast(
        platform === 'quickbooks'
          ? '✅ Switched to QuickBooks/Other (Xero disabled)'
          : '✅ Switched to Xero'
      );
    } catch (err) {
      // Save can fail when switching to Xero without invoice/expense codes saved
      // (the server enforces them for Xero users). Revert the optimistic toggle so
      // the UI matches what's actually persisted, and surface why.
      formData.update((current) => ({ ...current, accountingPlatform: previousPlatform }));
      error.set(err?.message || 'Failed to switch accounting platform.');
    }
  }
</script>

<SettingsLayout activeTab="accounting-platform" tabTitle="Accounting platform">
  <div class="p-4 bg-gray-50 border border-gray-200 rounded-lg">
    <p class="text-sm font-semibold text-gray-900 mb-1">Accounting platform</p>
    <p class="text-xs text-gray-500 mb-3">
      Choose how Buildzilla connects to your accounts software. <strong>QuickBooks</strong> users run JobTread-only — bills import to JobTread (which syncs to QuickBooks natively) and all Xero sync is disabled. Cost reporting and direct bill import stay enabled.
    </p>
    <div class="inline-flex rounded-md border border-gray-300 overflow-hidden">
      <button
        type="button"
        on:click={() => switchPlatform('xero')}
        class="px-4 py-2 text-sm font-medium transition-colors {$formData.accountingPlatform === 'xero' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}"
      >
        Xero
      </button>
      <button
        type="button"
        on:click={() => switchPlatform('quickbooks')}
        class="px-4 py-2 text-sm font-medium border-l border-gray-300 transition-colors {$formData.accountingPlatform === 'quickbooks' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}"
      >
        QuickBooks/Other
      </button>
    </div>
  </div>
</SettingsLayout>
